export default __webpack_public_path__ + "static/media/boite2.3d3fb38b.jpg";